import { IDatalayerKey, IDatalayerViewerFactory, LayerTypeId, LocaleString, NumericValuesViewer, ZoneTextLocation } from "../../omnia"
import { GenplanLayer } from "../genplanLayer"

export class GenericPlanViewer extends NumericValuesViewer {

    public static createFactory(): IDatalayerViewerFactory {

        return {
            typeId: LayerTypeId.GenericPlan,
            name: "Generic product plan" as LocaleString,
            createViewer: layer => new GenericPlanViewer(layer)
        }

    }

    public getValueFillColor(value: number, alpha: number = 1) {
        const color = super.getValueFillColor(value, alpha)
        return color || [255, 255, 255, 0.5]
    }

    getKey(): IDatalayerKey {

        const key = super.getKey()

        const layer = this._layer

        if (layer instanceof GenplanLayer) {

            const plan = layer.plan

            if (plan) {

                return {
                    ...key,
                    id: `genplan-${plan.GenericPlanId}`,
                    name: plan.Name,
                    fixed: true
                }
            }

        }

        return key

    }

    getValueText(value: number, location?: ZoneTextLocation): string {

        let text = super.getValueText(value, location)

        if (this._layer instanceof GenplanLayer) {

            if (location == ZoneTextLocation.Key) {

                const plan = this._layer.plan

                if (plan && plan.Labels) {
                    const label = plan.Labels[String(value)]
                    if (label) text = `${text} - ${label}`
                }

            }

        }

        return text

    }

    protected setupMinMaxZoneValues() {

        super.setupMinMaxZoneValues()

        if (!(this._layer instanceof GenplanLayer)) return

        const plan = this._layer.plan

        if (!plan) return

        const { MinRate, MaxRate } = plan

        this._minZoneValue = MinRate
        this._maxZoneValue = MaxRate

        const layers = this._layer.context.getAllLayers().concat([this._layer])

        layers.forEach(l => {

            if ((l instanceof GenplanLayer) && (l.planId == plan.GenericPlanId)) {

                const [min = 0, max = 0] = l.getMinMaxRates()

                this._minZoneValue = Math.min(this._minZoneValue || 0, min)
                this._maxZoneValue = Math.max(this._maxZoneValue || 0, max)
            }

        })

    }


}
